import React from 'react';

import ArrowBack from '@/assets/icons/arrow-back.svg?react';
import ArrowBackDark from '@/assets/icons/arrow-back-dark.svg?react';
import ArrowRight from '@/assets/icons/arrow-forward-full.svg?react';
import Cross from '@/assets/icons/cross.svg?react';

interface BackButtonProps {
  onGoBack: () => void;
  dark?: boolean;
  close?: boolean;
  arrow?: boolean;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  onGoBack,
  dark = false,
  close = false,
  arrow = false,
  className,
}) => {
  return (
    <button onClick={onGoBack} className={className}>
      {arrow ? (
        <ArrowRight className="rotate-180" />
      ) : close ? (
        <div>
          <Cross className="size-7 fill-dark-gray sm:size-9" />
        </div>
      ) : dark ? (
        <ArrowBackDark className="size-9" />
      ) : (
        <ArrowBack className="size-12" />
      )}
    </button>
  );
};

export default React.memo(BackButton);
